import Layout from "@/views/layout/Layout.vue";
const module_data_input = [
  {
    path: "/data-input",
    component: Layout,
    children: [
      {
        path: "collectDataList",
        name: "collectDataList",
        component: () => import("@/views/data-input/CollectDataList"),
        meta: {
          title: "信息管理",
          needLogin: true
        }
      },
      {
        path: "collectDataDetail",
        name: "collectDataDetail",
        component: () => import("@/views/data-input/CollectDataDetail"),
        meta: {
          title: "信息管理详情",
          needLogin: true
        }
      },
      {
        path: "collectSourceList",
        name: "collectSourceList",
        component: () => import("@/views/data-input/CollectSourceList"),
        meta: {
          title: "采集源管理",
          needLogin: true
        }
      },
      {
        path: "eventList",
        name: "eventList",
        component: () => import("@/views/data-input/EventList"),
        meta: {
          title: "事件库",
          needLogin: true
        }
      },
      {
        path: "createEvent",
        name: "createEvent",
        component: () => import("@/views/data-input/CreateEvent"),
        meta: {
          title: "事件新增",
          needLogin: true
        }
      },
      {
        path: "countryBase",
        name: "countryBase",
        component: () => import("@/views/data-input/CountryBase/index"),
        meta: {
          title: "国别基础信息库",
          needLogin: true
        }
      },
      {
        path: "addCountryData",
        name: "addCountryData",
        component: () => import("@/views/data-input/CountryBase/addCountryData"),
        meta: {
          title: "新增条目",
          needLogin: true
        }
      },
      {
        path: "editGuideData",
        name: "editGuideData",
        component: () => import("@/views/data-input/CountryBase/editGuideData"),
        meta: {
          title: "国别指南修改",
          needLogin: true
        }
      },
      {
        path: "responseLibrary",
        name: "responseLibrary",
        component: () => import("@/views/data-input/ResponseLibrary/index"),
        meta: {
          title: "应对库",
          needLogin: true
        }
      },
      {
        path: "addResponseLibraryData",
        name: "addResponseLibraryData",
        component: () => import("@/views/data-input/ResponseLibrary/addResponseLibraryData"),
        meta: {
          title: "新增条目",
          needLogin: true
        }
      },
      {
        path: "services",
        name: "services",
        component: () => import("@/views/data-input/services/index"),
        meta: {
          title: "安全服务",
          needLogin: true
        }
      },
      {
        path: "addServices",
        name: "addServices",
        component: () => import("@/views/data-input/services/addServices"),
        meta: {
          title: "新增条目",
          needLogin: true
        }
      },
      {
        path: "organizations",
        name: "organizations",
        component: () => import("@/views/data-input/organizations/index"),
        meta: {
          title: "恐怖组织信息库",
          needLogin: true
        }
      },
      {
        path: "addOrganizations",
        name: "addOrganizations",
        component: () => import("@/views/data-input/organizations/addOrganizations"),
        meta: {
          title: "新增条目",
          needLogin: true
        }
      },

      // 1.6 - 2020.10.26 新增
      {
        path: "articleList",
        name: "articleList",
        component: () => import("@/views/data-input/article/articleList"),
        meta: {
          title: "文章列表",
          needLogin: true,
        }
      },
      {
        path: "addArticle",
        name: "addArticle",
        component: () => import("@/views/data-input/article/addArticle"),
        meta: {
          title: "文章详情",
          needLogin: true
        }
      },
      {
        path: "category",
        name: "category",
        component: () => import("@/views/data-input/article/category"),
        meta: {
          title: "文章分类管理",
          needLogin: true
        }
      },
      {
        path: "addCategory",
        name: "addCategory",
        component: () => import("@/views/data-input/article/add_category"),
        meta: {
          title: "文章分类详情",
          needLogin: true
        }
      },
      {
        path: "articleField",
        name: "articleField",
        component: () => import("@/views/data-input/article/articleField"),
        meta: {
          title: "文章字段管理",
          needLogin: true
        }
      },
      {
        path: "viewComments",
        name: "viewComments",
        heddien: true,
        component: () => import("@/views/data-input/article/viewComments"),
        meta: {
          title: "查看评论",
          needLogin: true
        }
      },
      {
        path: "commentManagement",
        name: "commentManagement",
        component: () => import("@/views/data-input/article/commentManagement"),
        meta: {
          title: "评论管理",
          needLogin: true
        }
      },
      {
        path: "eventType",
        name: "eventType",
        component: () => import("@/views/data-input/article/eventType"),
        meta: {
          title: "事件类型管理",
          needLogin: true
        }
      },
      {
        path: "expertDatabase",
        name: "expertDatabase",
        component: () => import("@/views/data-input/database/expertDatabase"),
        meta: {
          title: "专家库",
          needLogin: true
        }
      },
      {
        path: "mediaLibrary",
        name: "mediaLibrary",
        component: () => import("@/views/data-input/database/mediaLibrary"),
        meta: {
          title: "媒体库",
          needLogin: true
        }
      },
      {
        path: "listofTopics",
        name: "listofTopics",
        component: () => import("@/views/data-input/special/listofTopics"),
        meta: {
          title: "专题列表",
          needLogin: true
        }
      },
      {
        path: "listofTopicsDetails",
        name: "listofTopicsDetails",
        heddien: true,
        component: () => import("@/views/data-input/special/listofTopicsDetails"),
        meta: {
          title: "专题详情",
          needLogin: true
        }
      },
      {
        path: "articleListView",
        name: "articleListView",
        heddien: true,
        component: () => import("@/views/data-input/article/articleListView"),
        meta: {
          title: "观点列表",
          needLogin: true
        }
      },
      {
        path: "statistics",
        name: "statistics",
        heddien: true,
        component: () => import("@/views/data-input/article/statistics"),
        meta: {
          title: "事件统计",
          needLogin: true
        }
      },
    ]
  }
];
export default module_data_input;
